export default "/static/images/build_base_5.png?52bb89dd101448de079cde6d80699819";